'use strict';

(function ($) {

  var searchForm = $('.jc-catalog-search-form'),
      brandElement = searchForm.find('.catalog-brand'),
      searchButton = searchForm.find('.catalog-search-button'),
      advancedSearchButton = searchForm.find('#advanced-search'),
      disableButton = searchButton.prop('disabled');

  $(window).bind("pageshow", function () {
    $(this.document).find('.catalog-brand').each(function () {
      $(this).trigger('change');
    });
  });

  //Clique do botão "Busca avançada", redireciona para a pagina de filtros
  advancedSearchButton.on('click', function (event) {
    event.preventDefault();
    var baseUrl = document.URL;
    baseUrl = baseUrl.replace('carros-0km/', "catalogo-0km-filtro");

    $(".texto").toggle();
    window.parent.location.href = baseUrl;
  });

  // Ao alterar marca
  brandElement.on('change', function () {

    var brand = $(this).val();
    var modelElement = $(this).closest('.jc-catalog-search-form').find('.catalog-model');

    if (brand && brand !== "Marca") {
      getModels(modelElement, brand);
    } else {
      modelElement.find('option:first').prop('selected', true);
      modelElement.attr('disabled', true);
      if (disableButton) {
        searchButton.attr('disabled', true);
      }
    }
  });

  // Opções de Modelo
  function getModels(modelElement, brand) {
    modelElement.attr('disabled', false);
    modelElement.find('option:first').prop('selected', true);
    modelElement.find('option').not(':first').hide();
    modelElement.find('[data-brand="' + brand + '"]').show();
    if (disableButton) {
      searchButton.attr('disabled', false);
    }
  }

  // Clique de botão do componente, redireciona para pagina 0km com filtro aplicado
  searchForm.submit(function (event) {

    event.preventDefault();

    var form = $(this);
    var baseUrl = form.data('filter-url');
    var newUrl = "";

    var brand = form.find('.catalog-brand').val();
    var model = form.find('.catalog-model').val();

    if (brand && brand != "Marca") {
      newUrl = baseUrl.replace("/carros-0km", "");
      newUrl += "catalogo-0km-filtro/?marcas=" + brand;
    }

    if (model && model != "Modelo") {
      newUrl = baseUrl + brand + '/' + model;
    }

    window.parent.location.href = newUrl;
  });
})(jQuery);